import {Component, EventEmitter, Injector, Input, Output} from '@angular/core';
import {IonItemSliding} from '@ionic/angular';
import {ControllerComponent} from '../../Controller/controller-component';
import {AssistantApiService} from '../../../Services/Api/Assistant/assistant-api.service';
import {AssistantConversationDto} from '../../../Models/Assistant/assistant-conversation.interface';

@Component({
  selector: 'app-assistant-menu',
  templateUrl: './assistant-menu.component.html',
  styleUrls: ['./assistant-menu.component.scss'],
  standalone: false,
})
export class AssistantMenuComponent extends ControllerComponent {

  @Input() conversations: AssistantConversationDto[] = [];
  @Output() conversationsChange: EventEmitter<AssistantConversationDto[]> = new EventEmitter<AssistantConversationDto[]>;

  @Output() newConversationClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() conversationClick: EventEmitter<AssistantConversationDto> = new EventEmitter<AssistantConversationDto>();

  showSearchbar: boolean = false;
  searchValue: string = '';

  visibleChatsCount: number = 5;

  constructor(
    protected override injector: Injector,
    protected assistantService: AssistantApiService,
  ) {
    super(injector);
  }


  /**
   * Mostrar/Ocultar barra de búsqueda
   *
   */
  toggleSearchbar() {
    this.showSearchbar = !this.showSearchbar;
    this.searchValue = '';
  }


  /**
   * Incrementar cantidad de chats visibles
   *
   */
  showMoreChats() {
    this.visibleChatsCount += 5;
  }


  /**
   * Nueva conversación
   *
   */
  async newConversation() {
    await this.menuCtrl.close();
    this.newConversationClick.emit();
  }


  /**
   * Seleccionar una conversación
   *
   */
  async selectConversation(conversation: AssistantConversationDto) {
    await this.menuCtrl.close();
    this.conversationClick.emit(conversation);
  }


  /**
   * Editar el título de la conversación
   *
   */
  async editConversationTitle(conversation: AssistantConversationDto, itemSld: IonItemSliding) {
    await itemSld.close();

    const alert = await this.alertCtrl.create({
      enterAnimation: this.animationCtrl.showAlertAnimation,
      leaveAnimation: this.animationCtrl.hideAlertAnimation,
      header: this.translate.instant('ASSISTANT.MENU.RENAME_CHAT_TITLE'),
      inputs: [
        {
          name: 'title',
          attributes: {'autocomplete': 'off'},
          placeholder: this.translate.instant('ASSISTANT.MENU.RENAME_CHAT_PLACEHOLDER'),
          value: conversation.title,
        },
      ],
      buttons: [
        {
          text: this.translate.instant('COMMON.CANCEL'),
          role: 'cancel'
        },
        {
          text: this.translate.instant('COMMON.SAVE'),
          role: 'destructive',
          handler: (data) => {
            this.saveConversationTitle(conversation, data.title);
          }
        }
      ]
    });

    await alert.present();
  }


  /**
   * Guarda el nuevo título del chat
   *
   */
  saveConversationTitle(conversation: AssistantConversationDto, title: string) {
    conversation.title = title || this.translate.instant('ASSISTANT.MENU.NO_TITLE');
    this.conversationsChange.emit(this.conversations);

    this.assistantService.renameConversation({id: conversation.id, title: conversation.title});
  }


  /**
   * Confirmar eliminar conversación
   *
   */
  async confirmDeleteConversation(conversation: AssistantConversationDto, itemSld: IonItemSliding) {
    await itemSld.close();

    const alert = await this.alertCtrl.create({
      enterAnimation: this.animationCtrl.showAlertAnimation,
      leaveAnimation: this.animationCtrl.hideAlertAnimation,
      header: this.translate.instant('ASSISTANT.MENU.DELETE_CHAT_TITLE'),
      message: this.translate.instant('ASSISTANT.MENU.DELETE_CHAT_MESSAGE'),
      buttons: [
        {
          text: this.translate.instant('COMMON.CANCEL'),
          role: 'cancel'
        },
        {
          text: this.translate.instant('COMMON.YES_DELETE'),
          role: 'destructive',
          handler: () => {
            this.deleteConversation(conversation);
          }
        }
      ]
    });

    await alert.present();
  }


  /**
   * Eliminar conversación
   *
   */
  deleteConversation(conversation: AssistantConversationDto) {
    this.conversations = this.conversations.filter((item) => item.id !== conversation.id);
    this.conversationsChange.emit(this.conversations);

    this.assistantService.deleteConversation(conversation.id);
  }

}
